<div>

    <div class="p-4"[formGroup]="form">
        <mat-form-field appearance="outline" class="my-8" style="width: 100%;">
            <mat-label>{{'COMPLAINTS.DETAIL.BUTTONS.ADD_COMMENT' | translate}}</mat-label>
            <textarea matInput rows="6" #textarea maxlength="maxLenght" formControlName="news"></textarea>
            <div style="display: flex;">
                <div style="display: flex;" *ngFor="let file of fileUploader.rawFiles">
                    <p class="px-4">{{!isMobile ? file.name : (file.name | slice:0:20) + '...'}}</p> 
                    <button mat-icon-button style="grid-area: cancel" (click)="fileUploader.removeFile(file)"><mat-icon>cancel</mat-icon></button>
                </div>
            </div>
        </mat-form-field>
        <div style="display: flex;" class="px-8">
            <app-simple-file-uploader
                class="uploader"
                #fileUploader
                multiple="true"
                allowedExtensions=".doc,.DOC,.docx,.DOCX,.xml,.XML,.odt,.ODT,.pdf,.PDF,.rtf,.RTF,.txt,.TXT,.wpd,.WPD,.jpg,.JPG,.png,.PNG,.csv,.CSV,.bmp,.BMP,.svg,.SVG,.tif,.TIF,.tiff,.TIFF,.ods,.ODS,.xls,.XLS,.xlsm,.XLSM,.xlsx,.XLSX,.mp4,.MP4,.mp3,.MP3,.m4a,.M4A,.msg,.MSG,.ogg,.OGG,.opus,.OPUS,.pptx,.PPTX,.eml,.EML,.aac,.AAC,.gif,.GIF,.jpeg,.JPEG">
            
                <button mat-raised-button color="accent" [disabled]="loading || viewMode" (click)="uploadFile()">
                    {{'ALERTS.COMPLETE_ALERT.BUTTONS.ADD_FILE' | translate}}
                </button>
            </app-simple-file-uploader>
            <button mat-raised-button color="primary" class="mx-8" (click)="addNew()" [disabled]="!form.get('news').value">
                {{'ALERTS.COMPLETE_ALERT.BUTTONS.ADD' | translate}}
            </button>
        </div>
    </div>
    <div *ngFor="let history of currentComments" class="my-8">
        <mat-card class="example-card">
            <div fxLayout="row wrap">
                <span class="font-size-12 text-italic" style="align-self: center;" fxFlex="1 0 auto" >{{history.createdBy}} - {{history.createdDate | date:'yyyy-MM-dd HH:mm'}}</span> 
                <div *ngIf="canRemoveComments">
                    <button mat-icon-button color="primary" class="mx-4" fxFlex="0 1 auto" (click)="removeObservation(history)">
                        <mat-icon>delete</mat-icon>
                    </button> 
                </div>
            </div>
            
            <div fxLayout="row wrap" fxLayoutAlign="flex-start center" class="mt-8 ml-24 p-8 comment-log">
            
                <span fxFlex="100%">{{history.comment}}</span>
            </div>

            <div>
                <ng-container *ngFor="let file of history.attachments">
                    <button mat-raised-button color="secondary" class="m-4" (click)="downloadNewsFiles(file)">
                        <mat-icon>get_app</mat-icon>{{!isMobile ? file.name : (file.name | slice:0:18) + '...'}}
                    </button>
                </ng-container>
            </div>
        </mat-card>
    </div>

</div>